import { Action } from "./action";
import { ActivateAction } from "../sceneActions/ActivateAction";
import { BackAction } from "../sceneActions/BackAction";
import { NavigateAction } from "../sceneActions/NavigateAction";
import { NavigateHomeAction } from "../sceneActions/NavigateHomeAction";
import { OpenAreaSizedModuleAction } from "../sceneActions/OpenAreaSizedModuleAction";
import { OpenFullscreenModuleAction } from "../sceneActions/OpenFullscreenModuleAction";
import { OpenSceneSizedModuleAction } from '../sceneActions/OpenSceneSizedModuleAction';
import { ToggleAction } from "../sceneActions/ToggleAction";
import { PlayAudioAction } from '../sceneActions/playAudio';
import { ExitModule } from "../sceneActions/ExitModule";
import { CallWebFunction } from "../sceneActions/CallWebFunction";

export class Actions {
  static typename = "actions";

  actions = [];

  addActionFromJson(j) {
    var a = newActionFromJson(j);
    this.actions.push(a);
  }

  parseJson(json) {
    for (let each in json) {
      if (each == Action.typename) {
        this.addActionFromJson(json[each]);
      } else if (each == Actions.typename) {
        for (let each_action in json[each]) {
          this.addActionFromJson(json[each][each_action]);
        }
      }
    }
  }

  runActions(param=undefined) {
    for (let each in this.actions) {
      this.actions[each].run(param);
    }
  }
}

export function newActionFromJson(json) {
  var verb = json.verb;
  var name = json.name;
  var obj;
  if (verb == "toggle") {
    obj = new ToggleAction(verb, name, json);
  } else if (verb == "navigate") {
    obj = new NavigateAction(verb, name, json);
  } else if (verb == "back") {
    obj = new BackAction(verb, name, json);
  } else if (verb == "home") {
    obj = new NavigateHomeAction(verb, name, json);
  } else if (verb == "activate") {
    obj = new ActivateAction(verb, name, json);
  } else if (verb == "openFullscreenModule") {
    obj = new OpenFullscreenModuleAction(verb, name, json);
  } else if (verb == "openAreaSizedModule") {
    obj = new OpenAreaSizedModuleAction(verb, name, json);
  } else if (verb == "openSceneSizedModule") {
    obj = new OpenSceneSizedModuleAction(verb, name, json);
  } else if (verb == "play audio") {
    obj = new PlayAudioAction(verb, name, json);
  } else if (verb == "ExitModule") {
    obj = new ExitModule(verb, name, json);
  } else if (CallWebFunction.verb_names.some(each => each == verb)) {
    obj = new CallWebFunction(verb, name, json);
  } else {
    console.warn("unknown action" + verb);
    obj = new Action(verb, name);
  }
  return obj;
}
